import React from "react";

type Props = React.LabelHTMLAttributes<HTMLLabelElement> & {
  text: string;
  required?: boolean;
  error?: boolean;
};

const Label: React.FC<Props> = ({ text, required, error, ...rest }) => {
  return (
    <label
      aria-label={text}
      {...rest}
      className="mb-1 block"
      style={{ color: error ? "red" : "" }}
    >
      {text}
      {required && <span className="ml-1">*</span>}
    </label>
  );
};

export default Label;
